import { OrderItemAction } from "Components/OrderItem/Redux/actions";

export enum OrderItemsIDs {
  VOUCHER = 'presentkort',
}

export interface IOrderItem {
  isFetching: boolean;
  isFetchFailed: boolean;
  isInvalidOrderItem: boolean;
  performance: Julius.Website.PerformanceOverviewViewModel;
  orderItemID: any;
}

const initialOrderItem: IOrderItem = {
  isFetching: false,
  isFetchFailed: false,
  isInvalidOrderItem: false,
  performance: null,
  orderItemID: null,
};

function orderItem(
  state: IOrderItem = initialOrderItem, 
  action: OrderItemAction,
  ): IOrderItem {

  switch (action.type) {
    case 'SET_ORDER_ITEM_ID':
      return {
        ...state,
        orderItemID: action.id,
      };

    case 'SET_PERFORMANCE':
      return {
        ...state,
        performance: action.performance,
        isFetching: false,
        isFetchFailed: false,
        orderItemID: action.performance.performanceID,
        isInvalidOrderItem: false,
      };

    case 'SET_IS_INVALID_ORDER_ITEM':
      return {
        ...state,
        isInvalidOrderItem: true,
      };

    case 'SET_IS_FETCHING_PERFORMANCE':
      return {
        ...state,
        isFetching: true,
        isFetchFailed: false,
        isInvalidOrderItem: false,
      };

    case 'SET_FETCH_PERFORMANCE_FAILED':
      return {
        ...state,
        isFetching: false,
        isFetchFailed: true,
      };

    case 'CLEAR_ORDER_ITEM':
      return initialOrderItem;

    default: 
      return state;
  }
}

export default orderItem;


// WEBPACK FOOTER //
// ./src/components/OrderItem/Redux/reducer.tsx